import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import SideMenuData from './SideMenuData';
import './index.scss';
import { LocalStorage } from 'app/utils/storage';
import {
  ALL_SIDEBAR_COMPONENT_ACCESS_KEYS,
  LocalSessionKey,
} from 'app/constants/app-constants';

const Sidebar = ({ initialsidebar, isLoading }) => {
  const location = useLocation();
  const [data, setData] = useState(SideMenuData);
  const activeItemRef = useRef(null);

  useEffect(() => {
    if (activeItemRef.current) {
      activeItemRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location.pathname]);
  const [sideMenuBar, setSideMenuBar] = useState([]);
  const user = JSON.parse(LocalStorage.get(LocalSessionKey.USER_INFO));

  useEffect(() => {
    if (user?.type === 'su') {
      setSideMenuBar([...ALL_SIDEBAR_COMPONENT_ACCESS_KEYS]);
    } else {
      setSideMenuBar([...initialsidebar]);
    }
  }, [ALL_SIDEBAR_COMPONENT_ACCESS_KEYS, initialsidebar]);

  const handleSubMenuClick = (itemId) => {
    const updatedData = data?.map((item) => {
      if (item.id === itemId) {
        item.active = !item.active;
      } else {
        item.active = false;
      }
      return item;
    });

    setData(updatedData);
  };

  if (isLoading) {
    return (
      <nav className='sidebar'>
        <ul className='sidebar-list list-unstyled m-0'>
          {Array.from({ length: 10 }).map((_, index) => (
            <li key={index} className='sidebar-item shimmer'>
              <div className='shimmer-content'></div>
            </li>
          ))}
        </ul>
      </nav>
    );
  }

  return sideMenuBar?.length ? (
    <nav className='sidebar'>
      <ul className='sidebar-list list-unstyled m-0'>
        {data?.map(
          (item, index) =>
            sideMenuBar?.includes(item.key) && (
              <React.Fragment key={index}>
                <li
                  ref={(ref) => {
                    if (location.pathname === item.to) {
                      activeItemRef.current = ref;
                    }
                  }}
                  className={`sidebar-item ${
                    location.pathname === item.to ? 'active-item' : ''
                  }`}
                >
                  <Link
                    to={item.to}
                    className={`${
                      location.pathname === item.to ? 'active' : ''
                    }`}
                    onClick={() => handleSubMenuClick(item.id)}
                  >
                    <img
                      className={`${
                        location.pathname === item.to ? 'active' : ''
                      }`}
                      src={item.icon}
                      alt={`${item.title} icon`}
                    />
                    {item.title}
                    {item.subNav && (
                      <span className='sidebar-arrow'>
                        {item.active ? item.iconOpened : item.iconClosed}
                      </span>
                    )}
                  </Link>
                </li>
                {item.subNav && item.active && (
                  <ul className='sub-menu p-0 m-0'>
                    {item.subNav.map((subItem, subIndex) => (
                      <li
                        key={subIndex}
                        ref={(ref) => {
                          if (location.pathname === subItem.to) {
                            activeItemRef.current = ref;
                          }
                        }}
                      >
                        <Link
                          to={subItem.to}
                          className={`sub-menu-link ${
                            location.pathname === subItem.to
                              ? 'active active-item'
                              : ''
                          }`}
                        >
                          {subItem.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </React.Fragment>
            )
        )}
      </ul>
    </nav>
  ) : (
    <nav>
      <ul className='sidebar-list list-unstyled m-0'>
        <li className='sidebar-item active-item pt-2 pb-2'>
          <Link className='active active-item sub-menu-link'>
            No Permission Assigned
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default Sidebar;
